"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDatalayerAnalyticsHandler = void 0;
const react_1 = require("react");
const use_datalayer_1 = require("../../lib/use-datalayer");
const types_1 = require("../../types");
const nullEvent = {
    event: null,
    eventAction: null,
    eventCategory: null,
    eventLabel: null,
    ecommerce: null,
};
function useDatalayerAnalyticsHandler(args) {
    const dataLayer = (0, use_datalayer_1.useDataLayer)(args?.dataLayerName ?? 'dataLayer');
    const transformObjectActionEvent = (0, react_1.useCallback)((event) => args?.transformObjectActionEvent?.(event) ?? event.legacy ?? [], [args]);
    return (0, react_1.useMemo)(() => ({
        async trackEvent(event) {
            if ('type' in event) {
                switch (event.type) {
                    case 'test':
                        return;
                    case 'legacy':
                        {
                            const data = event.data;
                            if ((0, types_1.isBaseLegacyEvent)(data)) {
                                dataLayer?.push(nullEvent);
                            }
                            dataLayer?.push(event.data);
                        }
                        break;
                    default: {
                        break;
                    }
                }
            }
            else {
                const items = transformObjectActionEvent(event);
                if (Array.isArray(items)) {
                    dataLayer?.push(...items);
                }
                else {
                    dataLayer?.push(items);
                }
            }
        },
    }), [dataLayer, transformObjectActionEvent]);
}
exports.useDatalayerAnalyticsHandler = useDatalayerAnalyticsHandler;
//# sourceMappingURL=analytics-handler.js.map